import PhoneWithCountries from 'react-phone-input-2'
import HelpBlock from 'components/partials/Fields/HelpBlock'
import { Form } from 'react-bootstrap'
import './styles.less'
import 'styles/vendors/react-phone-input-bootstrap.less'

const Phone = ({
    value,
    name = 'phone',
    country = 'us',
    containerClassName,
    id = name,
    onChange,
    label = 'Phone',
    help = 'Use country picker to change country code',
    className: fieldClassName = '',
    checkDup,
    required = true,
    feedbackClassName,
    error,
    frontEnd = true,
    ...props
}) => {
    return (
        <div className={`${containerClassName} form-group ${error && frontEnd && 'parsley-has-error'}`}>
            {label !== false ? <label htmlFor={name} className="control-label">{label}</label> : null}
            <PhoneWithCountries
                countryCodeEditable={false}
                country={country}
                specialLabel={false}
                value={value}
                onlyCountries={['us', 'ca']}
                preserveOrder={['onlyCountries']}
                placeholder=""
                jumpCursorToEnd={true}
                onChange={onChange}
                inputProps={{
                    required,
                    ...props,
                    className: `form-control ${fieldClassName} ${error && 'is-invalid'}`,
                    id: id || name,
                    error,
                }}
            />
            <HelpBlock help={help} />
            {frontEnd ? (
                error && <p className='parsley-errors-list filled'>{error}</p>
            ) : (
                <Form.Control.Feedback type="is-invalid" className={feedbackClassName}>
                    {error}
                </Form.Control.Feedback>
            )}
        </div>
    )
}

export default Phone
